<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">飞行任务</div>
      <el-form
        class="zj-search-form"
        ref="form"
        :model="form"
        :label-width="labelWidth"
      >
        <el-row>
          <el-form-item label="任务名称">
            <el-input
              v-model="taskNameLike"
              placeholder="请输入任务名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="任务类型">
            <el-select v-model="taskType" placeholder="请选择" clearable>
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in taskTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务状态">
            <el-select v-model="taskStatus" placeholder="请选择" clearable>
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in taskStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间段" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 68rem"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
        <div class="zj-table-container">
          <el-table
            v-loading="searching"
            element-loading-text="加载中..."
            :data="tableData"
            ref="multipleTable"
            border
            style="width: 100%"
            fixed
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="taskName"
              label="任务名称"
            ></el-table-column>
            <el-table-column
              prop="airRouteName"
              label="航线名称"
            ></el-table-column>
            <el-table-column
              prop="resourceName"
              label="无人机名称"
            ></el-table-column>
            <el-table-column
              prop="taskType"
              label="任务类型"
              align="center"
              :formatter="formatTaskType"
            ></el-table-column>
            <el-table-column
              prop="taskStatusStr"
              label="任务状态"
              align="center"
            >
              <template slot-scope="scope">
                <span :style="statusStyle(scope.row.taskStatus)">{{ scope.row.taskStatusStr }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="planStartTime"
              label="计划开始"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column
              prop="planEndTime"
              label="计划结束"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column
              prop="startTime"
              label="实际开始"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column
              prop="endTime"
              label="实际结束"
              align="center"
              :formatter="formatDate"
            ></el-table-column>
            <el-table-column
              prop="flightMileage"
              label="飞行里程"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="uavOperaePersonStr"
              label="飞手"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import { listUavTask } from "../../../apis/src/UavTaskApi";
export default {
  name: "UavTaskListView",
  controller: "UI",
  action: "uavTaskListView",
  data() {
    return {
      searching: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      date: [],
      taskNameLike: null,
      taskType: null,
      taskStatus: null,
      taskTypeOptions: [
        { value: 1, label: "巡航任务" },
        { value: 2, label: "临时任务" },
        { value: 3, label: "试飞任务" },
      ],
      taskStatusOptions: [
        { value: -2, label: "已过期" },
        { value: -1, label: "等待下发" },
        { value: 0, label: "执行失败" },
        { value: 1, label: "待执行" },
        { value: 2, label: "执行中" },
        { value: 3, label: "执行结束" },
      ],
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      this.searching = true;
      let startTime = null;
      let endTime = null;
      if (this.date && this.date.length === 2) {
        startTime = this.date[0].format("yyyy-MM-dd") + " 00:00:00";
        endTime = this.date[1].format("yyyy-MM-dd") + " 23:59:59";
      }
      let params = {
        taskNameLike: this.taskNameLike || undefined,
        taskType: this.taskType === "" ? undefined : this.taskType,
        taskStatus: this.taskStatus === "" ? undefined : this.taskStatus,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      listUavTask(params)
        .then((r) => {
          this.searching = false;
          this.tableData = r.rows || [];
          this.total = r.total || 0;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    onCancel() {
      this.date = [];
      this.taskNameLike = null;
      this.taskType = null;
      this.taskStatus = null;
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    formatDate(row, column) {
      let data = row[column.property];
      if (data == null || data === "") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
    formatTaskType(row, column) {
      let v = row[column.property];
      if (v === 1) return "巡航任务";
      if (v === 2) return "临时任务";
      if (v === 3) return "试飞任务";
      return v != null ? v : "";
    },
    statusStyle(status) {
      if (status === 2) return "color: #409EFF";
      if (status === 3) return "color: #67C23A";
      if (status === 0) return "color: #F56C6C";
      if (status === -2) return "color: #909399";
      return "color: #E6A23C";
    },
  },
};
</script>
